// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiImageListItem-root {
    margin-bottom: 2px !important;
    height: 100% !important;
    margin: 0px 2px !important;
    cursor: pointer;
}

.videoHome {
    width: 100%;
    /* height: 350px !important; */
    object-fit: cover;
}

.MuiImageList-root.masonryGrid {
    padding: 0px 40px;

}

.MuiBox-root.studioNavBox {
    padding: 0px 20px;
    margin-bottom: 2rem;
}

.overlay-container {
    position: relative;
    width: 100%;
    margin-bottom: 4px;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(43, 42, 42, 0.3);
    /* or #2B2A2A66 */
    opacity: 1;
    z-index: 2;
    pointer-events: none;
}

.MuiTypography-root.overlay-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFF;
    font-size: 24px;
    text-align: center;
    z-index: 3;
    font-family: var(--font-family-primary);
    font-weight: 400;
    width: 100%;
}

.MuiTypography-root.overlay-subtext {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    z-index: 3;
    font-family: var(--font-family-primary);
    font-weight: 400;
    width: 100%;
}

.MuiBox-root.footermansory {
    background-color: #4C518B;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 20px 20px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0%;
    z-index: 10;
    padding-top: 16px;
    padding-bottom: 16px;
    text-align: center;
}

.MuiTypography-root.footerText {
    font-family: var(--font-family-primary);
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1.5;
}

.MuiTypography-root.footerText span {
    color: #F2F2F2;
    font-weight: 600;

}

.MuiGrid-root.mainMansonryGrid {
    width: 100%;
    height: 100%;
    position: relative;
    margin: 0;
}

.MuiBox-root.scroll-container {
    flex: 1 1;
    height: calc(100vh - 221px);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding: 0;
    margin: 0;
}

.MuiBox-root.masonryGridContainer {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    padding: 0;
    margin: 0;
}

@media screen and (min-width: 768px) {
    .MuiBox-root.footermansory {
        height: 50px;
        padding: 0px 20px;
        bottom: 0;
    }


}
@media screen and (max-width: 460px) {
 .MuiImageList-root.masonryGrid {
    padding-bottom: 70px;
}
.MuiTypography-root.footerText {
    font-size: 10px;
}

}`, "",{"version":3,"sources":["webpack://./src/components/Home/Home.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,SAAS;IACb;;;AAGJ;AACA;CACC;IACG,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;;AAEA","sourcesContent":[".MuiImageListItem-root {\n    margin-bottom: 2px !important;\n    height: 100% !important;\n    margin: 0px 2px !important;\n    cursor: pointer;\n}\n\n.videoHome {\n    width: 100%;\n    /* height: 350px !important; */\n    object-fit: cover;\n}\n\n.MuiImageList-root.masonryGrid {\n    padding: 0px 40px;\n\n}\n\n.MuiBox-root.studioNavBox {\n    padding: 0px 20px;\n    margin-bottom: 2rem;\n}\n\n.overlay-container {\n    position: relative;\n    width: 100%;\n    margin-bottom: 4px;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(43, 42, 42, 0.3);\n    /* or #2B2A2A66 */\n    opacity: 1;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.MuiTypography-root.overlay-title {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #FFFFFF;\n    font-size: 24px;\n    text-align: center;\n    z-index: 3;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    width: 100%;\n}\n\n.MuiTypography-root.overlay-subtext {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #FFFFFF;\n    font-size: 16px;\n    text-align: center;\n    z-index: 3;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    width: 100%;\n}\n\n.MuiBox-root.footermansory {\n    background-color: #4C518B;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    padding: 20px 20px;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0%;\n    z-index: 10;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    text-align: center;\n}\n\n.MuiTypography-root.footerText {\n    font-family: var(--font-family-primary);\n    font-size: 14px;\n    font-weight: 400;\n    color: #FFFFFF;\n    line-height: 1.5;\n}\n\n.MuiTypography-root.footerText span {\n    color: #F2F2F2;\n    font-weight: 600;\n\n}\n\n.MuiGrid-root.mainMansonryGrid {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    margin: 0;\n}\n\n.MuiBox-root.scroll-container {\n    flex: 1;\n    height: calc(100vh - 221px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    padding: 0;\n    margin: 0;\n}\n\n.MuiBox-root.masonryGridContainer {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n}\n\n@media screen and (min-width: 768px) {\n    .MuiBox-root.footermansory {\n        height: 50px;\n        padding: 0px 20px;\n        bottom: 0;\n    }\n\n\n}\n@media screen and (max-width: 460px) {\n .MuiImageList-root.masonryGrid {\n    padding-bottom: 70px;\n}\n.MuiTypography-root.footerText {\n    font-size: 10px;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
